import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=16de11f5&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=16de11f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de11f5",
  null
  
)

export default component.exports